var map = {
	"./amazon-logo.png": 1555,
	"./asos-logo.png": 1556,
	"./cdiscount-logo.png": 1557,
	"./ebay-logo.png": 1558,
	"./facebook-marketplace-logo.png": 1559,
	"./google-merchant-logo.png": 1560,
	"./zalando-logo.png": 1561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1554;